(function(){
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
  const T=window.theme||{};
  const money=c=>{const f=T.moneyFormat||'${{amount}}';const a=(c/100).toFixed(2);return f.replace(/\{\{\s*(\w+)\s*\}\}/,(m,k)=>k==='amount_no_decimals'?Math.round(c/100).toLocaleString('en-US'):k==='amount_with_comma_separator'?a.replace('.',','):Number(a).toLocaleString('en-US',{minimumFractionDigits:2}))};

  /* menu */
  const mnav=$('#mnav');
  $$('[data-menu-open]').forEach(b=>b.addEventListener('click',()=>mnav&&mnav.classList.add('open')));
  $$('[data-menu-close]').forEach(b=>b.addEventListener('click',()=>mnav.classList.remove('open')));
  mnav&&mnav.addEventListener('click',e=>{if(e.target===mnav)mnav.classList.remove('open')});

  /* countdown */
  $$('[data-timer]').forEach(el=>{
    const hrs=+el.dataset.timer||2;let end;
    try{end=+sessionStorage.getItem('annTimer')}catch(e){}
    if(!end||end<Date.now()){end=Date.now()+hrs*3600e3;try{sessionStorage.setItem('annTimer',end)}catch(e){}}
    const h=$('[data-h]',el),m=$('[data-m]',el),s=$('[data-s]',el);
    const tick=()=>{let r=Math.max(0,end-Date.now())/1000;h.textContent=String(Math.floor(r/3600)).padStart(2,'0');m.textContent=String(Math.floor(r%3600/60)).padStart(2,'0');s.textContent=String(Math.floor(r%60)).padStart(2,'0')};
    tick();setInterval(tick,1000);
  });

  /* gallery */
  const gal=$('[data-gal]');
  if(gal){
    const slides=$$('.slide',gal),tw=$('[data-thumbs]');let gi=0;
    slides.forEach((s,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Image '+(i+1));
      if(s.dataset.thumb){const im=document.createElement('img');im.src=s.dataset.thumb;im.alt='';b.appendChild(im)}else b.textContent=s.dataset.thumbLabel||(i+1);
      b.addEventListener('click',()=>show(i));tw.appendChild(b)});
    const th=$$('button',tw);
    function show(i){gi=(i+slides.length)%slides.length;slides.forEach((s,k)=>s.classList.toggle('on',k===gi));th.forEach((t,k)=>t.classList.toggle('on',k===gi));th[gi]&&th[gi].scrollIntoView({block:'nearest',inline:'nearest'})}
    show(0);
    $('[data-gal-prev]')?.addEventListener('click',()=>show(gi-1));
    $('[data-gal-next]')?.addEventListener('click',()=>show(gi+1));
    $('[data-thumbs-prev]')?.addEventListener('click',()=>tw.scrollBy({left:-tw.clientWidth/2}));
    $('[data-thumbs-next]')?.addEventListener('click',()=>tw.scrollBy({left:tw.clientWidth/2}));
  }

  /* delivery date */
  $$('[data-delivery]').forEach(el=>{const d=new Date();let n=0,t=+el.dataset.delivery||4;while(n<t){d.setDate(d.getDate()+1);if(d.getDay()%6)n++}el.textContent=d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'})});

  /* buy box: clone for stock-up section */
  const box=$('[data-buybox]');
  $$('[data-buybox-clone]').forEach(t=>{
    if(!box)return;
    const c=document.createElement('div');
    ['.sold','.price-line','.bundles','.unlock','.ship-est','.pform','.sub-row'].forEach(sel=>{const n=$(sel,box);if(n)c.appendChild(n.cloneNode(true))});
    const f=$('form',c);if(f)f.removeAttribute('id');
    t.appendChild(c);
  });

  /* bundles */
  let selIndex=0;
  function applyBundle(i){
    selIndex=i;
    $$('.bundles').forEach(group=>{
      const bs=$$('[data-bundle]',group);if(!bs.length)return;
      const scope=group.closest('[data-buybox],[data-buybox-clone]')||document;
      bs.forEach((b,k)=>{b.classList.toggle('on',k===i);b.setAttribute('aria-checked',k===i)});
      const b=bs[i];if(!b)return;
      const set=(sel,v)=>$$(sel,scope).forEach(e=>e.textContent=v);
      set('[data-p-price]',b.dataset.price);set('[data-p-compare]',b.dataset.compare);set('[data-p-save]',b.dataset.save);
      set('[data-atc-price]',b.dataset.price);set('[data-atc-compare]',b.dataset.compare!==b.dataset.price?b.dataset.compare:'');
      $$('[data-variant-input]',scope).forEach(e=>e.value=b.dataset.variant);
      $$('[data-qty-input]',scope).forEach(e=>e.value=b.dataset.qty);
      $$('[data-gift-input]',scope).forEach(e=>{e.value=b.dataset.giftText||'';e.disabled=!b.dataset.giftText});
      const g=+b.dataset.gifts||0,ship=b.dataset.ship==='true';
      const un=[ship,g>=1,g>=2];
      $$('[data-gift]',scope).forEach(el=>el.classList.toggle('un',un[+el.dataset.gift-1]));
    });
    $$('[data-satc-price]').forEach(e=>{const b=$$('[data-buybox] [data-bundle]')[i];if(b)e.textContent=b.dataset.price});
  }
  const first=$$('[data-buybox] [data-bundle]');
  if(first.length){let d=first.findIndex(b=>b.classList.contains('on'));applyBundle(d<0?0:d)}
  document.addEventListener('click',e=>{
    const b=e.target.closest('[data-bundle]');
    if(b){const list=$$('[data-bundle]',b.closest('.bundles'));applyBundle(list.indexOf(b))}
    const pk=e.target.closest('[data-pick-bundle]');
    if(pk){applyBundle((+pk.dataset.pickBundle||1)-1);document.getElementById('buy')?.scrollIntoView({behavior:'smooth'})}
  });

  /* cart */
  const drawer=$('#drawer'),ov=$('#ov');
  function openCart(o){if(!drawer)return;drawer.classList.toggle('open',o);ov.classList.toggle('open',o);drawer.setAttribute('aria-hidden',!o)}
  $$('[data-cart-open]').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();refresh().then(()=>openCart(true))}));
  $$('[data-cart-close]').forEach(a=>a.addEventListener('click',()=>openCart(false)));
  function toast(t){const e=$('#toast');if(!e)return;e.textContent=t;e.classList.add('show');clearTimeout(e._t);e._t=setTimeout(()=>e.classList.remove('show'),2600)}
  async function refresh(){
    const c=await fetch('/cart.js').then(r=>r.json());
    $$('[data-cart-count]').forEach(e=>e.textContent=c.item_count);
    const items=$('#items');if(!items)return c;
    items.innerHTML=c.items.length?c.items.map(it=>`<div class="it"><div class="ti">${it.image?`<img src="${it.image}" alt="">`:''}</div><div><b>${it.product_title}</b>${it.variant_title&&it.variant_title!=='Default Title'?`<small>${it.variant_title}</small>`:''}${Object.entries(it.properties||{}).filter(([k,v])=>v&&k[0]!=='_').map(([k,v])=>`<small style="color:var(--accent);font-weight:600">🎁 ${v}</small>`).join('')}<span class="qty"><button type="button" aria-label="Decrease" data-ch="${it.key}" data-q="${it.quantity-1}">−</button><span>${it.quantity}</span><button type="button" aria-label="Increase" data-ch="${it.key}" data-q="${it.quantity+1}">+</button></span></div><div style="text-align:right"><b>${money(it.final_line_price)}</b>${it.original_line_price>it.final_line_price?`<s style="font-size:.8rem;color:#777">${money(it.original_line_price)}</s>`:''}<br><button type="button" class="rm" data-ch="${it.key}" data-q="0">Remove</button></div></div>`).join(''):`<div class="empty"><p>Your cart is empty.</p></div>`;
    $('#sub').textContent=money(c.total_price);
    const fb=$('#fb'),th=+fb.dataset.threshold||0;
    if(th>0){const left=th-c.total_price;fb.innerHTML=(left<=0?'🎉 You unlocked FREE shipping':`You're ${money(left)} away from FREE shipping`)+`<div class="bar"><i style="width:${Math.min(100,c.total_price/th*100)}%"></i></div>`}else fb.style.display='none';
    return c;
  }
  document.addEventListener('click',async e=>{
    const b=e.target.closest('[data-ch]');if(!b)return;
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:b.dataset.ch,quantity:+b.dataset.q})});
    refresh();
  });
  document.addEventListener('submit',async e=>{
    const f=e.target;if(!f.classList.contains('pform')&&!f.matches('form[action*="/cart/add"]'))return;
    e.preventDefault();
    const btn=f.querySelector('[type=submit]');btn&&(btn.disabled=true);
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)});
      if(!r.ok){const j=await r.json();toast(j.description||'Could not add to cart');}
      else{await refresh();openCart(true)}
    }catch(err){f.submit()}
    btn&&(btn.disabled=false);
  });
  $$('[data-satc-add]').forEach(b=>b.addEventListener('click',()=>{const f=$('[data-buybox] .pform');f&&f.requestSubmit()}));

  /* sticky atc */
  const atc=$('[data-buybox] .atc'),satc=$('#satc');
  if(atc&&satc&&'IntersectionObserver' in window){new IntersectionObserver(([en])=>satc.classList.toggle('show',!en.isIntersecting&&en.boundingClientRect.top<0)).observe(atc)}

  /* counters */
  if('IntersectionObserver' in window){
    const io=new IntersectionObserver(es=>es.forEach(en=>{if(!en.isIntersecting)return;const el=en.target,to=+el.dataset.count,suf=el.dataset.suf||'';let st=null;const run=t=>{st=st||t;const p=Math.min(1,(t-st)/1300);el.textContent=Math.floor(to*(1-Math.pow(1-p,3))).toLocaleString('en-US')+suf;if(p<1)requestAnimationFrame(run)};requestAnimationFrame(run);io.unobserve(el)}),{threshold:.5});
    $$('[data-count]').forEach(e=>io.observe(e));
  }

  /* carousels */
  $$('[data-carousel]').forEach(c=>{
    const tr=$('[data-track]',c),dots=$('[data-dots]',c);if(!tr)return;
    const step=()=>{const k=tr.children[0];return k?k.getBoundingClientRect().width+10:300};
    $('[data-prev]',c)?.addEventListener('click',()=>tr.scrollBy({left:-step()}));
    $('[data-next]',c)?.addEventListener('click',()=>tr.scrollBy({left:step()}));
    if(dots){const n=tr.children.length;dots.innerHTML=Array.from({length:n},()=>'<i></i>').join('');
      const upd=()=>{const i=Math.round(tr.scrollLeft/step());$$('i',dots).forEach((d,k)=>d.classList.toggle('on',k===Math.min(i,n-1)))};tr.addEventListener('scroll',upd,{passive:true});upd()}
  });

  /* videos: click to play */
  document.addEventListener('click',e=>{
    const v=e.target.closest('[data-vid]');if(!v)return;const vd=$('video',v);if(!vd)return;
    if(vd.paused){vd.muted=false;vd.play();v.classList.add('playing')}else{vd.pause();v.classList.remove('playing')}
  });

  /* track form */
  $$('[data-track-form]').forEach(f=>f.addEventListener('submit',e=>{e.preventDefault();const n=f.querySelector('input').value.trim();if(n)window.open(f.dataset.url+encodeURIComponent(n),'_blank')}));

  refresh().catch(()=>{});
})();
